import {
  Component,
  ComponentFactoryResolver,
  DestroyRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { Canonical_URL } from "app/metacontent";
import { componentDestroyed } from "ng2-rx-componentdestroyed";
import { NgxSpinnerService } from "ngx-spinner";
import { share, takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

import { Agent, User } from "@models/user";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { LoginService } from "@services/auth.service";
import { CommonService } from "@services/common.service";
import { RegistrationService } from "@services/registration.service";
import { SharedService } from "@services/shared.service";
import { YTBSEOService } from "@services/ytb-seo.service";

import { B2C_LOOKUP } from "../../lookup-config";
import { MustMatch } from "../sign-up/customvalidation/mustmatchvalidation";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

// declare var JSEncrypt: any;
@UntilDestroy()
@Component({
  selector: "app-create",
  templateUrl: "./agent.component.html",
  styleUrls: ["./agent.component.css"],
})
export class AgentComponent implements OnInit, OnDestroy {
  registrationForm: UntypedFormGroup;
  submitted: boolean = false;
  required: any;
  showSuccess: boolean = false;
  isUserID: boolean = false;
  countrydrop: Array<any>;
  allCountrydrop: Array<any>;

  countrycodes: Array<any>;
  showFail: boolean = false;
  lookup = B2C_LOOKUP;
  country_code: string;
  @ViewChild("isNavigated") isNavigated: ElementRef;
  @ViewChild(`signin`, { read: ElementRef }) private signin;
  @ViewChild("signincontainer", { read: ViewContainerRef })
  private signincontainer: ViewContainerRef;
  queryparamsInfo: any = {};
  redirectUrl: string = "";
  isNavigate: boolean = false;
  errorMessageText: Array<string> = [];
  successMessageText: Array<string> = [];
  maxDate: Date;
  key: string;
  ytbuser: any;
  geoCode: any;
  dateOfBirthNotInFormat: boolean;
  livingInCountryCode: any;
  showAgentForm = false;
  organizationTypes = [];
  agentForm: UntypedFormGroup;
  userType: "user" | "agent";
  stateList1 = [];
  stateList2 = [];
  countriesList = [];
  stateSequence: string;
  displaySignup: boolean = true;
  requestId: string;
  queryParamsInfo: any;
  isDisabled: boolean;
  private destroyRef = inject(DestroyRef);

  constructor(
    private fb: UntypedFormBuilder,
    private resolver: ComponentFactoryResolver,
    private commonservice: CommonService,
    private registerServc: RegistrationService,
    private elem: ElementRef,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private authService: LoginService,
    private ytbseo: YTBSEOService,
    private router: Router,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {

      let url = this.router.url.split("?");
        setTimeout(() => {
          this.ytbseo.createCanonicalURL(this.router.url);
          this.ytbseo.setDynamicTitle(url[0]);

        }, 3000);

    });


    this.agentForm = this.fb.group(
      {
        orgcode: new UntypedFormControl(),
        rmId: new UntypedFormControl(),
        orgRoleCodeId: new UntypedFormControl(),
        UserId: new UntypedFormControl("", [
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9 !@#$%^&*()-_=+\"|;:`~',<.>?/{}]+$"),
          this.userIdspaceValidator.bind(this),
        ]),
        FirstName: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
          this.spaceValidator.bind(this),
        ]),
        MiddleName: new UntypedFormControl("", [
          Validators.minLength(3),
          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
          this.spaceValidator.bind(this),
        ]),
        LastName: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
          this.spaceValidator.bind(this),
        ]),
        PhoneNumber: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(5),
          Validators.pattern("^[1-9][0-9]*$"),
        ]),
        dob: new UntypedFormControl(null, [
          Validators.required,
          Validators.minLength(10),
          this.ageValidator().bind(this),
          this.commonservice.validateDate,
        ]),
        phoneCodeiso2: new UntypedFormControl("", [Validators.required]),
        Password: new UntypedFormControl("", [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(
            "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})"
          ),
        ]),
        Email: new UntypedFormControl("", [
          Validators.required,
          Validators.email,
          ,
          Validators.pattern(
            "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)\\.([a-zA-Z0-9]{2,4})+$"
          ),
        ]),
        Confirmpassword: new UntypedFormControl("", [Validators.required]),
        AcceptTerms: new UntypedFormControl("", [Validators.required]),
        IdDocs: new UntypedFormControl(""),
        Address: this.initAddress("agentAddress"),
        Organization: this.initOrganization(),
      },
      {
        validator: MustMatch("Password", "Confirmpassword"),
      }
    );

    this.registrationForm = this.fb.group({
      countryiso2: new UntypedFormControl(),
      UserId: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9 !@#$%^&*()-_=+\"|;:`~',<.>?/{}]+$"),
        ,
        this.userIdspaceValidator.bind(this),
      ]),
      FirstName: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
        this.spaceValidator.bind(this),
      ]),
      MiddleName: new UntypedFormControl("", [
        Validators.minLength(3),
        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
        this.spaceValidator.bind(this),
      ]),
      LastName: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
        this.spaceValidator.bind(this),
      ]),
      PhoneNumber: new UntypedFormControl("", [
        Validators.minLength(5),
        Validators.pattern("^[1-9][0-9]*$"),
      ]),
      dob: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(10),
        this.ageValidator().bind(this),
        this.commonservice.validateDate,
      ]),
      phoneCodeiso2: new UntypedFormControl(""),
      phoneCodeiso22: new UntypedFormControl(""),
      Password: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(6),
        Validators.pattern(
          "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})"
        ),
      ]),
      Email: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
        ,
        Validators.pattern(
          "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)\\.([a-zA-Z0-9]{2,4})+$"
        ),
      ]),
      Confirmpassword: new UntypedFormControl("", [Validators.required]),
      AcceptTerms: new UntypedFormControl("", [Validators.required]),
      IdDocs: new UntypedFormControl(""),
      Address: this.initAddress("orgAddress"),
      Organization: this.initOrganization(),
    });

    this.authService.getAllIndustryTypes();

    this.authService.GetIndustryTypesSuccess.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((params) => {
      console.log(params, "  Inside of Agent component 82 ");
      if (params) {
        // this.organizationTypes = [{
        //   "id": '',
        //   "industryType": "--Select--",
        //   "isActive": null,
        //   "createdBy": null,
        //   "createdDate": null,
        //   "modifiedBy": null,
        //   "modifiedDate": null
        // }]
        this.organizationTypes = [
          {
            id: "",
            industryType: "--Select--",
          },
          ...params.result,
        ];
      }
    });

    this.maxDate = new Date();
    this.initUserForm();
    this.getCountrycode();

    this.sharedService.signupRedirectUrl$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((redirectUrl) => {
        if (redirectUrl) {
          this.redirectUrl = redirectUrl;
        }
      });

    this.sharedService.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((params) => {
      if (params) {
        this.livingInCountryCode = params.countryCode;
      }
    });

    this.commonservice.countrySignupSuccess$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((countryRes) => {
        if (countryRes != null && countryRes != undefined) {
          this.allCountrydrop = countryRes.result;
          this.countrydrop = this.commonservice.prepareDropdownResponse(
            countryRes.result,
            "countryName",
            "countryISO2",
            "Country"
          );
          this.countrycodes =
            this.commonservice.preparePhoneCodesDropdownResponse(
              countryRes.result,
              "countryName",
              "countryISO2",
              "countryImage",
              "countryPhoneCode",
              "countryISO3",
              "Country Code"
            );
          this.countrycodes = this.countrycodes.filter((item) => {
            return item.value != "null";
          });
          let item = this.countrycodes.find(
            (x) => x.value == this.livingInCountryCode
          );
          if (item) {
            this.registrationForm.controls["phoneCodeiso2"].setValue(
              item.value
            );
          }
          if (this.livingInCountryCode) {
          }

          
    if (
      this.router.url.includes("search/flights") ||
      this.router.url.includes("lp/flights") ||
      this.router.url.includes("flight-details") ||
      this.router.url.includes("book/flight") ||
      this.router.url.includes("coupons")
    ) {
   

    
    this.userType = "agent";
    this.switchToUserOrAgent("agent");
    }else{
      this.route.queryParams.subscribe((param) => {
        setTimeout(() => {
          if (param && !this.isObjectEmpty(param)) {
            this.requestId = param["userKey"];
            console.log(this.requestId, "  nagaraju");
            this.spinner.show();
            this.commonservice.getAgentSignupQueryParamsInfo(this.requestId);
          }
  
          this.userType = "agent";
          this.switchToUserOrAgent("agent");
        });
      });
    }
        }
      });

    this.registerServc.onFailure
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response) {
          this.spinner.hide();
           this.commonservice.logError({
                logLevel: "Error page Navigation Before",
                message:
                  "registerServc onFailure From Agent Component "
              });
          if (response.exceptionSource == "RegisterFailed") {
            this.router.navigate(["error"]);
          }
        }
      });

      

    this.registerServc.RegistrationSuccess.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((registerres) => {
      console.log(JSON.stringify(registerres), "   207");
      if (registerres && registerres.statusCode === 1) {
        this.spinner.hide();
        let mainMessage="Email Confirmation Sent Successfully", warningMessage="We have sent you a Confirmation for your registered Email Address. Please Confirm Your Email By clicking the Link in your Email Address to Confirm your account";
        if (registerres?.messageInfo?.uiSuccessMessge && registerres?.messageInfo?.uiSuccessMessge.length > 0)
          mainMessage = registerres.messageInfo.uiSuccessMessge[0];
        if (registerres?.messageInfo?.uiWarningMessge && registerres?.messageInfo?.uiWarningMessge.length > 0)
          warningMessage = registerres.messageInfo.uiWarningMessge[0];
        
        this.sharedService.closeRefereFrom();
        Swal.fire({
          imageUrl: "assets/images/envelope.png",
          title: mainMessage,
          allowOutsideClick: false,
          text: warningMessage,
        }).then((ok) => {
          if (
            this.router.url.includes("search/flights") ||
            this.router.url.includes("lp/flights") ||
            this.router.url.includes("flight-details") ||
            this.router.url.includes("book/flight") ||
            this.router.url.includes("coupons")
          ) { 
            return;
          }
          if (this.signin) {
            this.signin.nativeElement.click();
          }
          this.logIn();
        });

        this.registrationForm.reset();
      } else if (registerres && registerres.statusCode === 0) {
        this.showFail = true;
        this.showSuccess = false;
        this.successMessageText = registerres.messageInfo.uiErrorMessage;
        this.spinner.hide();
      } else {
        this.spinner.hide();

        this.showFail = true;
        this.showSuccess = false;
        this.successMessageText.push(
          "Unable to Process your request at this time"
        );
      }
    });

    this.registerServc.RegistrationB2BSuccess.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((registerres) => {
      console.log(JSON.stringify(registerres), "   241");
      this.isDisabled = false;
      if (registerres && registerres.statusCode === 1) {
        this.spinner.hide();
        this.sharedService.closeRefereFrom();
        setTimeout(()=> {
        Swal.fire({
          imageUrl: "assets/images/envelope.png",
          title: "Email Confirmation Sent Successfully",
          allowOutsideClick: false,
          text: "We have sent you a Confirmation for your registered Email Address. Please Confirm Your Email By clicking the Link in your Email Address to Confirm your account",
        }).then((ok) => {
          this.agentForm.reset();
          
          if (
            this.router.url.includes("search/flights") ||
            this.router.url.includes("lp/flights") ||
            this.router.url.includes("flight-details") ||
            this.router.url.includes("book/flight") ||
            this.router.url.includes("coupons")
          ) { 
            return;
          }
          if (this.signin) {
            this.signin.nativeElement.click();
          }
          this.logIn();
        });
        this.registrationForm.reset();
        },500);
      } else if (registerres && registerres.statusCode === 0) {
        this.showFail = true;
        this.showSuccess = false;
        this.successMessageText = registerres.messageInfo.uiErrorMessage;
        this.spinner.hide();
      } else {
        this.spinner.hide();

        this.showFail = true;
        this.showSuccess = false;
        this.successMessageText.push(
          "Unable to Process your request at this time"
        );
      }
    });

    this.authService.LoginSuccess.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((payload) => {
      if (
        payload != undefined &&
        payload != null &&
        payload.result != undefined &&
        payload.result != null &&
        payload.result != "PI" &&
        payload.result != "PU" &&
        payload.result != "UI" &&
        payload.result.status &&
        payload.result.status != "PUS"
      ) {
        this.spinner.hide();
        // localStorage.setItem("UserObj", JSON.stringify(payload.result));
        // let id = JSON.parse(localStorage.getItem("UserObj"));
        // localStorage.setItem("UserID", id.userName);
        // this.sharedService.setUserIdAfterLogin(id.userName);

        this.sharedService.setUserIdAfterLogin(payload.result.userName);
        this.sharedService.setLoginUserDetails(payload.result);

        this.sharedService.loginSuccess.next(true);
      }
    });

    this.commonservice.keySuccess$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((key) => {
        if (key != null && key != undefined) {
          this.key = key.data;
        }
      });

    this.sharedService.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((geoCode) => {
      if (geoCode != null && geoCode != "" && geoCode != undefined) {
        this.geoCode = geoCode;
        this.livingInCountryCode = geoCode.countryCode;
      }
    });

    this.commonservice.StateList.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res) => {
        if (res && res.result) {
          if (this.stateSequence === "state1") {
            // this.stateList1 = res.result;
            this.stateList1 = this.commonservice.prepareDropdownResponse(res.result, 'state_Name', 'state_Code');
          } else {
            this.stateList2 = res.result;
          }
        }
      }
    );

    this.commonservice.AGENTSIGNUPQUERYPARAMSGETSUCESS$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      if (res.result && res.result.requestObj) {
        this.spinner.hide();
        this.queryParamsInfo = JSON.parse(res.result.requestObj);
        console.log(JSON.stringify(this.queryParamsInfo), "   nagaraju");
        this.agentForm.controls["orgcode"].setValue(
          this.queryParamsInfo?.orgcode
        );
        this.agentForm.controls["orgRoleCodeId"].setValue(
          this.queryParamsInfo?.OrgRoleCodeId
        );
        this.agentForm.controls["rmId"].setValue(this.queryParamsInfo?.RmId);
        this.agentForm.controls["Email"].setValue(this.queryParamsInfo?.Email);
        this.isDisabled = true;
      } else {
        this.spinner.hide();
         this.commonservice.logError({
                logLevel: "Error page Navigation Before",
                message:
                  "Link Expired Contact Your Organization Manager to generate new link AGENTSIGNUPQUERYPARAMSGETSUCESS From Agent Component "
              });
        this.router.navigate(["error"], {
          queryParams: {
            module: "login",
            message: [
              "Link Expired Contact Your Organization Manager to generate new link",
            ],
          },
        });
      }
    });
  }
  get f() {
    return this.registrationForm.controls;
  }

  get addressForm() {
    return this.agentForm.get("address") as UntypedFormGroup;
  }

  get agentAddress() {
    return this.agentForm.get("Address") as UntypedFormGroup;
  }

  get organization() {
    return this.agentForm.get("Organization") as UntypedFormGroup;
  }

  closePopUp() {
    this.displaySignup = !this.displaySignup;

    // if (this.closebtn) {
    //   this.closebtn.nativeElement.click();
    // }
  }

  ShowDropdown(event) {
    // return event.value.length >= 3;
    return true;
  }

  allowOnlyChars(event: any) {
    var pattern = new RegExp("^[a-zA-Z ]+$");
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  allowOnlyNum(event) {}

  ngAfterViewInit() {
    // this.renderer.listen(
    //   this.elem.nativeElement.querySelector("input#uniqueUserID"),
    //   "blur",
    //   this.checkUserIDExist.bind(this)
    // );

    if (this.isNavigate) {
      if (
        this.isNavigated.nativeElement.classList.contains("col-12") &&
        this.isNavigated.nativeElement.classList.contains("col-lg-8")
      ) {
        this.renderer.removeClass(this.isNavigated.nativeElement, "col-12");
        this.renderer.removeClass(this.isNavigated.nativeElement, "col-lg-8");
        this.renderer.addClass(this.isNavigated.nativeElement, "col-md-12");
      } else {
        this.renderer.removeClass(this.isNavigated.nativeElement, "col-md-12");
        this.renderer.addClass(this.isNavigated.nativeElement, "col-12");
        this.renderer.addClass(this.isNavigated.nativeElement, "col-lg-8");
      }
    }
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      ".ng-invalid[formControlName]"
    );
    this.scrollTo(firstElementWithError);

    console.log(this.agentForm.controls);
    for (const key of Object.keys(this.agentForm.controls)) {
      console.log(this.agentForm.controls[key]);
      if (this.agentForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        console.log(invalidControl);
        break;
      }
    }
  }

  /**
   * @author : Sindhuri Punati
   * @description:this method is used to register new customer in B2C
   *
   */ onSubmit() {
    this.submitted = true;

    this.showFail = false;
    this.showSuccess = false;
    this.successMessageText = [];
    if (this.registrationForm.valid && !this.isUserID) {
      // if (this.registrationForm.controls["phoneCodeiso2"].value) {
      //   let phoneObj = this.countrycodes.find(
      //     (x) =>
      //       x.value == this.registrationForm.controls["phoneCodeiso2"].value
      //   );
      //   this.registrationForm.controls["phoneCodeiso2"].setValue(phoneObj.iso2);
      // }

      let user = new User();
      user.loggedin_Country = this.geoCode.countryCode;
      let dateOfBirth = this.registrationForm.controls["dob"].value;
      let userObj = user.assignFormObj(this.registrationForm.value);

      userObj.dob = this.commonservice.getDateAddFromString(dateOfBirth, "-");
      userObj.userType = 0;
      userObj.userTypeStr = "User";
      userObj.countryiso2 =
        this.registrationForm.controls["phoneCodeiso2"].value;
      userObj.phoneCodeiso2 =
        this.registrationForm.controls["phoneCodeiso2"].value;
      this.spinner.show();
      this.ytbuser = userObj;

      this.ytbuser && this.ytbuser["Confirmpassword"]
        ? delete this.ytbuser["Confirmpassword"]
        : true;
      // var jsencrypt = new JSEncrypt();
      // jsencrypt.setPublicKey(this.key);
      this.ytbuser.Password = this.commonservice.encryptData(
        JSON.stringify(this.ytbuser.Password),this.key
      );
      // jsencrypt = null;
      this.registerServc.register(this.ytbuser);
    } else {
      this.commonservice.validateAllFormFields(this.registrationForm);
      this.registrationForm.markAllAsTouched();

      this.scrollToError();
    }
    for (const key of Object.keys(this.registrationForm.controls)) {
      if (this.registrationForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        invalidControl.focus();
        break;
      }
    }
  }

  ageValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      let birthdate = control.value;
      const dob = new Date(birthdate);
      const dateToCompare = new Date();
      let numberOfDaysToAdd = Math.ceil(
        (dateToCompare.getFullYear() - dob.getFullYear()) / 4
      );
      dateToCompare.setDate(dateToCompare.getDate() - numberOfDaysToAdd);

      const dobOnly = new Date(
        dob.getFullYear(),
        dob.getMonth(),
        dob.getDate()
      ).getTime();
      const dateToCompareOnly = new Date(
        dateToCompare.getFullYear(),
        dateToCompare.getMonth(),
        dateToCompare.getDate()
      ).getTime();

      const age = (dateToCompareOnly - dobOnly) / (365 * 24 * 60 * 60 * 1000);
      let psgrage = age;

      if (psgrage > 100) {
        return { age: true };
      } else {
        return null;
      }
    };
  }

  dateOfBirthDate(event) {
    const currentCode = event.which;
    let currentKey = event.key;
    const dateOfBirth =
      this.userType === "user"
        ? this.registrationForm.controls["dob"].value.toString()
        : this.agentForm.controls["dob"].value.toString();

    if (event.key != "Unidentified") {
      if (!isNaN(event.key)) {
        if (
          [46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
          (event.keyCode === 65 && event.ctrlKey === true) ||
          (event.keyCode === 67 && event.ctrlKey === true) ||
          (event.keyCode === 86 && event.ctrlKey === true) ||
          (event.keyCode === 88 && event.ctrlKey === true) ||
          (event.keyCode === 65 && event.metaKey === true) ||
          (event.keyCode === 67 && event.metaKey === true) ||
          (event.keyCode === 86 && event.metaKey === true) ||
          (event.keyCode === 88 && event.metaKey === true) ||
          (event.keyCode >= 35 && event.keyCode <= 39)
        ) {
          return;
        }
        if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105)
        ) {
          event.preventDefault();
        } else {
          if (dateOfBirth) {
            this.setDateOfBirthToForm(event, dateOfBirth);
          }
        }
      } else {
        event.preventDefault();
      }
    } else {
      if (dateOfBirth) {
        let lastValue = dateOfBirth.substring(dateOfBirth.length - 1);

        if (!isNaN(lastValue) && event.keyCode > 105) {
          this.setDateOfBirthToForm(event, dateOfBirth);
        } else {
          let lastValue1 = dateOfBirth.substring(0, dateOfBirth.length - 1);
          this.registrationForm.controls["dob"].setValue(lastValue1);
        }
      }
    }
  }

  checkWheatherStrinHasValidSlashOrNot(value: string) {
    if (value.length <= 3 && value.length <= 6) {
      value.substr(1, 2);
    }

    if (value.length <= 3) {
    }

    if (value.length <= 3) {
    }
  }

  setDateOfBirthToForm(event, dob) {
    var pattern = /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/;
    var date = new Date();
    var newDateFormat = "";
    if (date.getMonth() < 10) {
      newDateFormat += "0" + date.getMonth();
    } else {
      newDateFormat += date.getMonth();
    }
    if (dob.length == 3 && event.keyCode != 8) {
      if (dob[2] != "/") {
        dob = dob.substring(0, 2) + "/" + dob.substring(2, dob.length);
      }
    }
    if (dob.length == 6 && event.keyCode != 8) {
      if (dob[5] != "/") {
        dob = dob.substring(0, 5) + "/" + dob.substring(5, dob.length);
      }
    }
    if (dob.length == 2 && event.keyCode != 8) {
      dob += "/";
    } else if (
      dob.length == 10 &&
      dob.substring(6, 10) === date.getFullYear() &&
      dob.substring(0, 2) > newDateFormat
    ) {
    } else if (dob.length == 2 && dob > 12) {
    }
    if (dob.length == 5 && event.keyCode != 8) {
      dob += "/";
    } else if (dob.length == 5 && dob.substring(3, 5) > 31) {
    }
    if (dob.length == 10) {
    }
    if (this.userType === "user") {
      this.registrationForm.controls["dob"].setValue(dob);
    } else {
      this.agentForm.controls["dob"].setValue(dob);
    }
  }

  ngOnDestroy() {
    this.registerServc.dispose();
  }

  spaceValidator(dateOfBirthVal: AbstractControl) {
    let nameValue = dateOfBirthVal.value;
    if (nameValue) {
      if (nameValue) {
        let indexValue = nameValue.indexOf("  ");
        if (indexValue >= 0) {
          return { space: true };
        } else {
          return null;
        }
      }
    }
    return null;
  }

  userIdspaceValidator(dateOfBirthVal: AbstractControl) {
    let nameValue = dateOfBirthVal.value;
    if (nameValue) {
      if (nameValue) {
        let indexValue = nameValue.indexOf(" ");
        if (indexValue >= 0) {
          return { userIdSpace: true };
        } else {
          return null;
        }
      }
    }
    return null;
  }

  /**
   *  @author : Sindhuri Punati
   * @description:it checkes email exist or not in the database
   */
  checkUserIDExist() {
    this.isUserID = false;
    this.errorMessageText = [];
    const userIdControl =
      this.userType === "user"
        ? this.registrationForm.controls["UserId"]
        : this.agentForm.controls["UserId"];
    const userid =
      this.userType === "user"
        ? this.registrationForm.controls["UserId"].value
        : this.agentForm.controls["UserId"].value;
    if (userIdControl.valid && userid) {
      this.registerServc.getUserId({ userId: userid.trim() });
      this.registerServc.UserIDFinder.pipe(
        takeUntilDestroyed(this.destroyRef),
        share()
      ).subscribe((res) => {
        if (res && res.statusCode == 0) {
          this.errorMessageText = res.messageInfo.uiErrorMessage;
          this.isUserID = true;
        } else if (res && res.statusCode == 1) {
          this.isUserID = false;
        }
      });
    }
  }

  /**
   *  @author : Sindhuri Punati
   * @description:this method display countries dropdown list
   */

  countriesDropdown() {
    this.commonservice.getSignupCountries();
  }

  getCountrycode() {
    this.commonservice.getSignupCountries();
  }

  logIn() {
    this.closePopUp();
    this.sharedService.navigateToSigninFromSignup(true);
  }

  checkVal() {
    this.errorMessageText = [];
    this.isUserID = false;

    this.showFail = false;
    this.showSuccess = false;
    this.successMessageText = [];
  }

  navigateToCoupons() {
    this.router.navigate(["/coupons"]);
  }

  initUserForm() {
    // this.registrationForm = this.fb.group(
    //   {
    //     UserId: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.pattern("^[a-zA-Z0-9 !@#$%^&*()-_=+\"|;:`~',<.>?/{}]+$"),
    //       ],
    //     ],
    //     FirstName: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ],
    //     MiddleName: [
    //       "",
    //       [
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ],
    //     LastName: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ],
    //     PhoneNumber: [
    //       "",
    //       [Validators.minLength(5), Validators.pattern("^[1-9][0-9]*$")],
    //     ],
    //     dob: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(10),
    //         this.ageValidator().bind(this),
    //         this.commonservice.validateDate,
    //       ],
    //     ],
    //     countryiso2: [""],
    //     phoneCodeiso2: [null],
    //     phoneCodeiso22: [null],
    //     Email: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.email,
    //         Validators.pattern(
    //           "[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}.[a-zA-Z]{2,4}"
    //         ),
    //       ],
    //     ],
    //     Password: [
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(6),
    //         Validators.pattern(
    //           "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})"
    //         ),
    //       ],
    //     ],
    //     Confirmpassword: ["", [Validators.required]],
    //     AcceptTerms: ["", Validators.requiredTrue],
    //   },
    //   {
    //     validator: MustMatch("Password", "Confirmpassword"),
    //   }
    // );
  }

  initAgentRegistrationForm() {
    // this.agentForm = this.fb.group(
    //   {
    //     UserId: new FormControl("", [Validators.required]),
    //     FirstName: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ),
    //     MiddleName: new FormControl(
    //       "",
    //       [
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ),
    //     LastName: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(3),
    //         Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),
    //         this.spaceValidator.bind(this),
    //       ],
    //     ),
    //     PhoneNumber: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(5),
    //         Validators.pattern("^[1-9][0-9]*$"),
    //       ],
    //     ),
    //     dob: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(10),
    //         this.ageValidator().bind(this),
    //         this.commonservice.validateDate,
    //       ],
    //     ),
    //     phoneCodeiso2: new FormControl(),
    //     Email: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.email,
    //         Validators.pattern(
    //           "[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}.[a-zA-Z]{2,4}"
    //         ),
    //       ],
    //     ),
    //     Password: new FormControl(
    //       "",
    //       [
    //         Validators.required,
    //         Validators.minLength(6),
    //         Validators.pattern(
    //           "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})"
    //         ),
    //       ],
    //     ),
    //     Confirmpassword: new FormControl("", [Validators.required]),
    //     AcceptTerms: new FormControl("", [Validators.requiredTrue]),
    //     IdDocs: new FormControl(""),
    //     Address: this.initAddress("agentAddress"),
    //     Organization: this.initOrganization(),
    //   },
    //   {
    //     validator: MustMatch("Password", "Confirmpassword"),
    //   }
    // );
  }

  initAddress(addressType: "agentAddress" | "orgAddress") {
    return this.fb.group({
      street1: new UntypedFormControl("", this.checkRequiredValidation(addressType)),
      street2: new UntypedFormControl(""),
      country: new UntypedFormControl("", this.checkRequiredValidation(addressType)),
      state: new UntypedFormControl(""),
      city: new UntypedFormControl("", this.checkRequiredValidation(addressType)),
      zip: new UntypedFormControl("", this.checkRequiredValidation(addressType)),
    });
  }

  initOrganization() {
    return this.fb.group({
      name: new UntypedFormControl(""),
      type: new UntypedFormControl("NC"),
      license: new UntypedFormControl(""),
      logo: new UntypedFormControl(""),
      description: new UntypedFormControl(""),
      businessType: new UntypedFormControl(""),
      noOfEmployees: new UntypedFormControl(""),
      address: this.initAddress("orgAddress"),
    });
  }

  switchToUserOrAgent(userType: "agent" | "user", fromHtml: boolean = false) {
    console.log(userType, fromHtml, "  nagaraju");
    if (fromHtml) {
      // this.router.navigate(['/SignupUser']);
      this.sharedService.navigateToSignupFromSigning(true);
    } else {
      this.userType = userType;
      const countryCode = this.countrycodes.find(
        (x) => x.value == this.livingInCountryCode
      );
      console.log(countryCode, "  nagaraju");
      if (userType === "user") {
        // this.initUserForm();
        // this.agentForm.clearValidators();
        this.registrationForm.controls["phoneCodeiso2"].setValue(
          countryCode.value
        );
      } else {
        // this.initAgentRegistrationForm();
        // this.registrationForm.clearValidators();
        this.agentForm.controls["phoneCodeiso2"].setValue(countryCode.value);
      }
    }
  }

  isObjectEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  getStates(event, stateSequence: string) {
    this.stateSequence = stateSequence;
    if(stateSequence=="state1"){
      let country = this.allCountrydrop.find(x => x.countryISO2 === event.value);
      console.log(country);
      if (country && country?.isStateMandatory) {
        this.agentAddress.get('state').setValidators([Validators.required]);
      } else {
        this.agentAddress.get('state').clearValidators();

      }
      this.agentAddress.get('state').updateValueAndValidity();

    }
    this.commonservice.getState(event.value);
  }

  validator(formType) {
    if (this.agentAddress  && this.agentAddress.get('state')) {
      if (this.agentAddress.get('state').validator) {
        const validator = this.agentAddress.get('state').validator({} as AbstractControl);
        if (validator && validator.required) {
          return true;
        }
      }

    }
  }

  onAgentRegistrationSubmit() {
    this.submitted = true;
    this.showFail = false;
    this.showSuccess = false;
    this.successMessageText = [];
    console.log(
      this.isUserID,
      this.agentForm.controls["phoneCodeiso2"].value,
      "    "
    );
    if (this.agentForm.valid && !this.isUserID) {
      // if (this.agentForm.controls["phoneCodeiso2"].value) {
      //   let phoneObj = this.countrycodes.find(
      //     (x) => x.value == this.agentForm.controls["phoneCodeiso2"].value
      //   );
      //   this.agentForm.controls["phoneCodeiso2"].setValue(phoneObj.iso2);
      // }
      this.spinner.show();
      let user = new Agent();
      user.countryiso2 = this.agentForm.controls["phoneCodeiso2"].value;
      user.loggedin_Country = this.geoCode.countryCode;
      let dateOfBirth = this.agentForm.controls["dob"].value;
      const agentFormObj = this.agentForm.value;
      if (agentFormObj.Organization.type) {
        agentFormObj.Organization.industryTypeId =
          this.organization.get("type").value["id"];
        if (this.organization.get("type").value["industryType"] === "Travel")
          agentFormObj.Organization.license = "";
      }

      agentFormObj.Organization.organizationAddress =
        agentFormObj.Organization.address;

      let userObj = user.assignFormObj(agentFormObj);
      userObj.dob = this.commonservice.getDateAddFromString(dateOfBirth, "-");
      userObj.userType = 1;
      userObj.userTypeStr = "Agent";
      userObj.userDetails = this.requestId;
      this.spinner.show();
      this.ytbuser = userObj;
      this.ytbuser.userAddress = agentFormObj.Address;
      console.log(userObj.address);
      console.log(this.ytbuser);
      console.log(JSON.stringify(agentFormObj));

      this.ytbuser.userAddress["address1"] = agentFormObj.Address.street1;
      this.ytbuser.userAddress["address2"] = agentFormObj.Address.street2;
      this.ytbuser.userAddress["zipCode"] = agentFormObj.Address.zip;

      this.ytbuser.Organization.noOfEmployees =
        this.ytbuser.Organization.noOfEmployees.toString();

      this.ytbuser.Organization.organizationAddress["address1"] =
        agentFormObj.Organization.address.street1;
      this.ytbuser.Organization.organizationAddress["address2"] =
        agentFormObj.Organization.address.street2;
      this.ytbuser.Organization.organizationAddress["zipCode"] =
        agentFormObj.Organization.address.zip;

      this.ytbuser && this.ytbuser["Confirmpassword"]
        ? delete this.ytbuser["Confirmpassword"]
        : true;

      delete this.ytbuser.Address;
      delete this.ytbuser.userAddress.street1;
      delete this.ytbuser.userAddress.street2;
      delete this.ytbuser.Organization.organizationAddress.street1;
      delete this.ytbuser.Organization.organizationAddress.street2;
      delete this.ytbuser.Organization.type;

      // var jsencrypt = new JSEncrypt();
      // jsencrypt.setPublicKey(this.key);
      this.ytbuser.Password = this.commonservice.encryptData(
        JSON.stringify(this.ytbuser.Password),this.key
      );
      // jsencrypt = null;
      console.log(JSON.stringify(this.ytbuser));
      this.registerServc.agentRegister(this.ytbuser);
    } else {
      this.commonservice.validateAllFormFields(this.agentForm);
      this.commonservice.validateNestedFormArrayFields(this.agentAddress);
      this.scrollToError();
    }
  }

  checkRequiredValidation(addressType: "agentAddress" | "orgAddress") {
    if (addressType === "agentAddress") {
      return [Validators.required];
    } else {
      return [];
    }
  }

     getError(control: AbstractControl | null, name: string): string | null {
      if (
        control &&
        control.touched &&
        control.errors &&
        control.errors["required"]
      ) {
        return `${name} is required.`;
      } else if (control && control.errors && control.value) {
        if (control.errors["minlength"]) {
          const requiredLength = control.errors['minlength'].requiredLength;
          return `Please enter minimum ${requiredLength} characters`;
        } else if (control.errors["pattern"]) {
          return `${name} must be in valid format`;
        } else if (control.errors["space"]) {
          return `Only one space allows between the letters`;
        } else if (control.errors["dobInvalid"]) {
          return ` Age should be less than 100 years. Please enter a valid Date of Birth`;
        } else if (control.errors["mustmatch"]) {
          return `Passwords must match`;
        } else if (control.errors["email"]) {
          return `Please enter a valid email address`;
        } else if (control.errors["userIdSpace"]) {
          return `Spaces are not allowed in User ID`;
        }
      }
      return null;
    }
}
